import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel2";
import { NavLink, withRouter } from "react-router-dom";
import { IsEmpty, redirectToUrl } from "../../../util/commonFunctions";
import { showLoader, hideLoader } from "../../../actions";
import { connect } from "react-redux";

// crousel
class Carousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        margin: 30,
        rewind: false,
        autoWidth: true,
        autoplay: false,
        dots: false,
        loop: false,
        responsive: {
          992: {
            nav: true,
            slideBy: 5
          },
          768: {
            nav: true,
            slideBy: 4
          },
          480: {
            nav: true,
            slideBy: 3
          },
          320: {
            nav: true,
            slideBy: 2
          }
        }
      }
    };
  }

  componentDidMount = () => {
    // this.refs.car.goTo(options.startPosition);
  };

  componentDidUpdate = () => {
    // this.refs.car.goTo(this.state.options.startPosition);
  };

  getNav = subNav => {
    const returnSubNav = subNav.map((nav, index) => {
      return (
        <NavLink
          to={{
            pathname: `/topic${nav.tierInUrl}?topicID=${nav.id}`
          }}
          key={nav.name + index}
          onClick={() => this.props.onTierClicked(nav)}
        >
          {!IsEmpty(nav.navLabel) ? nav.navLabel : nav.name}
        </NavLink>
      );
    });
    return returnSubNav;
  };

  getCompanyNav = subNav => {
    const returnSubNav = subNav.map((nav, index) => {
      return (
        <a key={index} href={`/topic/${nav.name}/${nav.id}`}
         onClick={event =>
          redirectToUrl(
            event,
            nav.id,
            this.props,
            this.props.showLoader,
            this.props.hideLoader,
            this.props.currentLanguage
          )
        }>{!IsEmpty(nav.navLabel) ? nav.navLabel : nav.name}</a>
      );
    });
    return returnSubNav;
  };

  render = () => {
    // const options = { ...this.state.options, ...this.props.crouselOption };

    const events = {
      onDragged: function(event) {},
      onChanged: function(event) {},
      onTranslate: function(event) {}
    };
    return (
      <React.Fragment>
        {this.props.data && (
          <OwlCarousel ref="car" options={this.state.options} events={events}>
            {this.props.isCompanyPage ? this.props.isExpertPage ?
            <div style={{marginTop:"3px"}}><a  className="staticText">EXPERTISE</a></div> :
            <div style={{marginTop:"3px"}}><a  className="staticText">RELATED TOPICS</a></div> : <></>
            }
            {this.props.isCompanyPage ? this.getCompanyNav(this.props.data) : this.getNav(this.props.data)}
          </OwlCarousel>
        )}
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    currentLanguage: state.language.currentLanguage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Carousel));
